"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios = require('axios');
var browser_or_node_1 = require("browser-or-node");
var models_1 = require("./models");
var lodash_1 = require("lodash");
var date_fns_1 = require("date-fns");
var helpers = __importStar(require("./helper"));
var translationsBaseUrl = 'https://us-central1-translatorapp-as.cloudfunctions.net/translations/v2';
/**
 * This label queue class
 */
var LabelSaverQueue = /** @class */ (function () {
    function LabelSaverQueue(options) {
        this.BATCH_SIZE = 10;
        this.queue = [];
        this.inMemoryStore = {};
        this.options = options;
        if (!options.labelStore) {
            options.labelStore = new InternalStore();
        }
        try {
            this.inMemoryStore = JSON.parse(this.options.labelStore.getItem('translations')) || {};
        }
        catch (e) {
            this.inMemoryStore = {};
        }
    }
    LabelSaverQueue.prototype.getBatch = function () {
        var result = [];
        for (var i = 0; i < this.BATCH_SIZE; i++) {
            var data = this.queue.pop();
            if (data) {
                result.push(data);
            }
            else {
                break;
            }
        }
        return result;
    };
    LabelSaverQueue.prototype.startWatch = function () {
        var _this = this;
        this.interval = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var batch, response, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.queue.length > 0)) return [3 /*break*/, 5];
                        batch = this.getBatch();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all(batch.map(function (label) {
                                return _this.savelabel(label);
                            }))];
                    case 2:
                        response = _a.sent();
                        // we filter out the empty responses
                        response = response.filter(function (res) { return !lodash_1.isEmpty(res); });
                        // For all the responses, we process it and move the label appropriately
                        response.forEach(function (res) {
                            if (res.movedToGlobal) {
                                // 1. if the moved label was already completed
                                if (res.label.done) {
                                    _this.app.segments['global-labels'].completed += 1;
                                    _this.app.segments[res.fromSegment].completed -= 1;
                                }
                                // 2. update where the label was moved from
                                _this.app.segments[res.fromSegment].totalLabels -= 1;
                                _this.app.segments[res.fromSegment].lastUpdated = new Date();
                                if (_this.inMemoryStore[res.fromSegment]) {
                                    _this.inMemoryStore[res.fromSegment].segment = _this.app.segments[res.fromSegment];
                                    delete _this.inMemoryStore[res.fromSegment].labels[res.label.id];
                                }
                                // 3. Update where the label was moved to
                                var globalSegment = _this.app.segments['global-labels'];
                                globalSegment.totalLabels += 1;
                                globalSegment.lastUpdated = new Date();
                                _this.inMemoryStore['global-labels'].segment = globalSegment;
                                _this.inMemoryStore['global-labels'].labels[res.label.id] = res.label;
                                // 4. remove the optimistic update to the label in the inMemory store
                                delete _this.inMemoryStore[res.intendedSegment].labels[res.label.id];
                            }
                            else {
                                var segment = _this.app.segments[res.label.segmentId];
                                segment.totalLabels += 1;
                                segment.lastUpdated = new Date();
                                _this.inMemoryStore[res.label.segmentId].segment = segment;
                                _this.inMemoryStore[res.label.segmentId].labels[res.label.id] = res.label;
                            }
                        });
                        // here we save the translator app
                        if (response.length > 0) {
                            this.options.labelStore.setItem('translations', JSON.stringify(this.inMemoryStore));
                            this.saveTranslatorApp(this.app);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        console.log(e_1);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.stopWatch();
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); }, 10000);
    };
    LabelSaverQueue.prototype.stopWatch = function () {
        clearInterval(this.interval);
        this.interval = null;
    };
    LabelSaverQueue.prototype.addToQueue = function (label) {
        console.log('Save: ', label);
        this.queue.push(label);
        if (!this.interval) {
            this.startWatch();
        }
    };
    LabelSaverQueue.prototype.savelabel = function (label) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios.put(translationsBaseUrl + "/" + _this.options.appId + "/labels", { label: label, secret: _this.options.secret, appId: _this.options.appId })
                            .then(function (res) {
                            resolve(res.data);
                        })
                            .catch(function (e) {
                            reject(e);
                        });
                    })];
            });
        });
    };
    LabelSaverQueue.prototype.updateLabelToServer = function (label) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios.put(translationsBaseUrl + "/" + _this.options.appId + "/labels-update", { label: label, secret: _this.options.secret, appId: _this.options.appId })
                            .then(function (res) {
                            resolve(res.data);
                        })
                            .catch(function (e) {
                            reject(e);
                        });
                    })];
            });
        });
    };
    LabelSaverQueue.prototype.saveTranslatorApp = function (app) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        axios.put(translationsBaseUrl + "/" + _this.options.appId, { app: app, secret: _this.options.secret })
                            .then(function (res) {
                            resolve();
                        })
                            .catch(function (e) {
                            reject(e);
                        });
                    })];
            });
        });
    };
    return LabelSaverQueue;
}());
/**
 * This internal store class
 */
var InternalStore = /** @class */ (function () {
    function InternalStore() {
        this.store = {};
    }
    InternalStore.prototype.getItem = function (prop) {
        return this.store[prop];
    };
    InternalStore.prototype.setItem = function (prop, data) {
        this.store[prop] = data;
    };
    InternalStore.prototype.clear = function () {
        this.store = {};
    };
    InternalStore.prototype.removeItem = function (prop) {
        delete this.store[prop];
    };
    return InternalStore;
}());
/**
 * This translator service class
 */
var TranslatorClientService = /** @class */ (function (_super) {
    __extends(TranslatorClientService, _super);
    function TranslatorClientService(options) {
        var _this = _super.call(this, options) || this;
        _this.clientDomain = browser_or_node_1.isBrowser ? location.hostname : '';
        _this.appLanguages = [];
        return _this;
    }
    // @TODO make this an interval that runs every one hour
    TranslatorClientService.prototype.init = function () {
        var _this = this;
        var addStarredLabels = lodash_1.isEmpty(this.inMemoryStore);
        return new Promise(function (resolve, reject) {
            axios.get(translationsBaseUrl + "/" + _this.options.appId + "?starred=" + addStarredLabels + "&syncAuth=" + browser_or_node_1.isBrowser)
                .then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            data = res.data;
                            return [4 /*yield*/, this.setup(data)];
                        case 1:
                            _a.sent();
                            resolve(null);
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (e) {
                console.log(e);
                reject(e);
            });
        });
    };
    TranslatorClientService.prototype.setup = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var outDatedSegmentIds_1, segments_1, labels;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.appLanguages = data.appLanguages;
                        this.app = data.app;
                        this.syncAuth = data.syncAuth;
                        if (browser_or_node_1.isBrowser && !this.options.defaultLanguage) {
                            this.options.defaultLanguage = window.navigator.language.split('-')[0];
                        }
                        if (browser_or_node_1.isNode && !this.options.defaultLanguage) {
                            this.options.defaultLanguage = this.appLanguages[0].symbol;
                        }
                        if (!lodash_1.isEmpty(this.inMemoryStore)) return [3 /*break*/, 1];
                        this.groupLabelsAndSave(lodash_1.values(data.app.segments).filter(function (segment) { return segment.starred; }), data.starredLabels);
                        return [3 /*break*/, 3];
                    case 1:
                        // Here we prune non used segments first
                        this.pruneUnUsedlabels();
                        outDatedSegmentIds_1 = [];
                        segments_1 = [];
                        lodash_1.keys(this.inMemoryStore).forEach(function (segmentId) {
                            if (date_fns_1.isBefore(_this.inMemoryStore[segmentId].segment.lastUpdated, data.app.segments[segmentId].lastUpdated)) {
                                segments_1.push(data.app.segments[segmentId]);
                                outDatedSegmentIds_1.push(segmentId);
                            }
                        });
                        if (!(outDatedSegmentIds_1.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getLabelsForSegments(outDatedSegmentIds_1)];
                    case 2:
                        labels = _a.sent();
                        this.groupLabelsAndSave(segments_1, labels);
                        _a.label = 3;
                    case 3: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    TranslatorClientService.prototype.getAppLanguages = function () {
        return this.appLanguages;
    };
    TranslatorClientService.prototype.setDefaultLanguage = function (languageSymbol) {
        // if the language is among the supported languages, we use that
        // else we ignore
        var language = this.appLanguages.find(function (lang) { return lang.symbol === languageSymbol; });
        if (language) {
            this.options.defaultLanguage = language.symbol;
        }
    };
    TranslatorClientService.prototype.getlabels = function (segmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var labelsProvider;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        labelsProvider = {
                            _translate: function (label, variableMap) {
                                if (label) {
                                    return _this.translate(segmentId, label, variableMap);
                                }
                                return label;
                            }
                        };
                        if (!!this.inMemoryStore[segmentId]) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.addNewSegment(segmentId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/, Promise.resolve({
                            data: new Proxy(labelsProvider, {
                                get: function (target, key) {
                                    if (key === '_translate') {
                                        return target[key];
                                    }
                                    else {
                                        return labelsProvider._translate(key);
                                    }
                                }
                            })
                        })];
                }
            });
        });
    };
    TranslatorClientService.prototype.addNewSegment = function (segmentId) {
        return __awaiter(this, void 0, void 0, function () {
            var labels, segment, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.app.segments[segmentId]) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getLabelsForSegments([segmentId])];
                    case 1:
                        labels = _a.sent();
                        this.groupLabelsAndSave([this.app.segments[segmentId]], labels);
                        return [3 /*break*/, 6];
                    case 2:
                        if (!this.canSync()) return [3 /*break*/, 6];
                        segment = {
                            id: segmentId,
                            totalLabels: 0,
                            completed: 0,
                            dateAdded: new Date(),
                            lastUpdated: new Date(),
                            starred: false
                        };
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        this.app.segments[segmentId] = segment;
                        // save to the database
                        return [4 /*yield*/, this.saveTranslatorApp(this.app)];
                    case 4:
                        // save to the database
                        _a.sent();
                        // here we sync
                        this.groupLabelsAndSave([segment], []);
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _a.sent();
                        console.log(e_2);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    TranslatorClientService.prototype.translate = function (segmentId, labelId, variableMap) {
        var result;
        if (this.inMemoryStore[segmentId]) {
            var label_1;
            // here we first check if it is in the global name space
            var globalHaslabel = this.inMemoryStore['global-labels'].labels[labelId];
            var segmentHaslabel = this.inMemoryStore[segmentId].labels[labelId];
            if (globalHaslabel || segmentHaslabel) {
                label_1 = globalHaslabel || segmentHaslabel;
                if (variableMap) {
                    // @TODO we could remove this line but do a data migration to make sure
                    // @TODO that the all labels in the db has a variables field
                    label_1.variables = label_1.variables || {};
                    var _a = helpers.eliminateSimilarities(lodash_1.keys(variableMap), lodash_1.keys(label_1.variables)), added = _a[0], removed = _a[1];
                    if (added.length > 0) {
                        added.forEach(function (key) {
                            label_1.variables[key] = {
                                id: key,
                                description: ''
                            };
                        });
                    }
                    if (removed.length > 0) {
                        removed.forEach(function (key) { return delete label_1.variables[key]; });
                    }
                    if (added.length > 0 || removed.length > 0) {
                        this.updateLabel(label_1);
                    }
                }
                else {
                    // If no variable map, we clear what was already there
                    if (lodash_1.keys(label_1.variables).length > 0) {
                        label_1.variables = {};
                        this.updateLabel(label_1);
                    }
                }
            }
            else {
                this.addNewLabel(segmentId, labelId, variableMap);
            }
            if (label_1) {
                result = label_1.values[models_1.LanguageTypes[this.options.defaultLanguage]];
            }
        }
        // If the label has variables we interpolate else we just return the values
        if (result && variableMap) {
            return this.interpolate(result, variableMap);
        }
        else {
            return result || labelId;
        }
    };
    TranslatorClientService.prototype.updateLabel = function (label) {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Update: ', label);
                        // we add the label optimistically to memory
                        this.inMemoryStore[label.segmentId].labels[label.id] = label;
                        if (!this.canSync()) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.updateLabelToServer(label)];
                    case 2:
                        _a.sent();
                        this.options.labelStore.setItem('translations', JSON.stringify(this.inMemoryStore));
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        console.log(e_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TranslatorClientService.prototype.addNewLabel = function (segmentId, labelId, variableMap) {
        return __awaiter(this, void 0, void 0, function () {
            var variables, label;
            return __generator(this, function (_a) {
                variables = {};
                if (variableMap) {
                    lodash_1.keys(variableMap).forEach(function (key) {
                        variables[key] = {
                            id: key,
                            description: ''
                        };
                    });
                }
                label = {
                    id: labelId,
                    label: labelId,
                    segmentId: segmentId,
                    done: false,
                    values: {},
                    variables: variables
                };
                this.appLanguages.forEach(function (languge) {
                    label.values[languge.id] = '';
                });
                // we add the label optimistically to memory
                this.inMemoryStore[segmentId].labels[label.id] = label;
                if (this.canSync()) {
                    // here we add the label save operation to queue
                    this.addToQueue(label);
                }
                return [2 /*return*/];
            });
        });
    };
    // This method removes all segments store on the client side
    // that no longer exists on the main app
    TranslatorClientService.prototype.pruneUnUsedlabels = function () {
        var _this = this;
        lodash_1.values(this.inMemoryStore).forEach(function (segment) {
            if (!(_this.app.segments[segment.segment.id])) {
                delete _this.inMemoryStore[segment.segment.id];
            }
        });
        this.options.labelStore.setItem('translations', JSON.stringify(this.inMemoryStore));
    };
    TranslatorClientService.prototype.getLabelsForSegments = function (segmentIds) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            axios.post(translationsBaseUrl + "/" + _this.options.appId + "/labels", { segmentIds: segmentIds, appId: _this.app.id })
                .then(function (res) {
                resolve(res.data);
            })
                .catch(function (e) {
                reject(e);
            });
        });
    };
    TranslatorClientService.prototype.groupLabelsAndSave = function (segments, labels) {
        var _this = this;
        segments.forEach(function (segment) {
            _this.inMemoryStore[segment.id] = {
                segment: segment,
                labels: {}
            };
        });
        labels.forEach(function (label) {
            _this.inMemoryStore[label.segmentId].labels[label.id] = label;
        });
        this.options.labelStore.setItem('translations', JSON.stringify(this.inMemoryStore));
    };
    TranslatorClientService.prototype.canSync = function () {
        if (this.options.sync) {
            return (browser_or_node_1.isBrowser && this.syncAuth.allowedDomains.indexOf(this.clientDomain) >= 0) ||
                (browser_or_node_1.isNode && !!this.options.secret);
        }
        return false;
    };
    TranslatorClientService.prototype.interpolate = function (templateStr, variableMap) {
        // use custom delimiter {{ }} as used in the the labels
        lodash_1.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
        // interpolate
        var compile = lodash_1.template(templateStr);
        return compile(variableMap);
    };
    return TranslatorClientService;
}(LabelSaverQueue));
exports.TranslatorClientService = TranslatorClientService;
